import React from 'react';
export function RefreshIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.012 4.012a1 1 0 00-1 1v1.374A8.918 8.918 0 0012.013 3H12a9.012 9.012 0 00-9 8.986 1 1 0 102 0A7.009 7.009 0 0112 5h.009a6.95 6.95 0 015.737 3.009h-1.74a1 1 0 100 2l4 .006a1 1 0 001-1l.006-4a1 1 0 00-1-1.003zM20 11.012a1 1 0 00-1 1A7.008 7.008 0 0112 19h-.012a6.974 6.974 0 01-5.735-3.01H8a1 1 0 100-2l-4-.005a1 1 0 00-1 1l-.006 4a1 1 0 001 1 1 1 0 001-1v-1.373A8.954 8.954 0 0011.986 21H12a9.01 9.01 0 009-8.986 1 1 0 00-1-1.002z"
  }));
}